<template>
  <ModalCustom
    :isVisible="props.isVisible"
    @close="emit('close')"
    class="var-modal"
  >
    <header class="flex flex-column text-center">
      <h2 class="subtitle-4">{{ $t("challenge.modal.tiersPrizes") }}</h2>
      <p class="body-4" style="color: #4b5563">
        {{ $t("challenge.modal.tiersPrizesDesc") }}
      </p>
    </header>

    <section
      class="flex flex-column gap-5 p-4 border-round-xl"
      style="background-color: #ecf1f7"
    >
      <!-- Legend Tier -->
      <div
        class="flex flex-column sm:flex-row sm:justify-content-between sm:gap-3"
      >
        <div class="flex flex-row gap-2 align-items-center">
          <span class="material-symbols-outlined tier-icon-bg crown mid">
            crown
          </span>
          <div
            class="flex flex-column sm:flex-row sm:align-items-center sm:gap-1"
          >
            <h3 class="body-4-bold" style="color: #344555">
              {{ $t("challenge.modal.legend") }}:
            </h3>
            <p class="body-4 text-gray-600">
              {{ $t("challenge.modal.legendTier") }}
            </p>
          </div>
        </div>

        <span class="body-4-bold text-right ml-5 sm:ml-0 w-fit">
          {{ $t("challenge.modal.legendGold") }}
        </span>
      </div>

      <!-- Master Tier -->
      <div
        class="flex flex-column sm:flex-row sm:justify-content-between sm:gap-3"
      >
        <div class="flex flex-row gap-2">
          <span class="material-symbols-outlined tier-icon-bg">
            award_star
          </span>

          <div
            class="flex flex-column sm:flex-row sm:align-items-center sm:gap-1"
          >
            <h3 class="body-4-bold" style="color: #344555">
              {{ $t("challenge.modal.master") }}:
            </h3>
            <p class="body-4 text-gray-600">
              {{ $t("challenge.modal.masterTier") }}
            </p>
          </div>
        </div>
        <span class="body-4-bold text-right ml-5 sm:ml-0 w-fit">
          {{ $t("challenge.modal.masterGold") }}
        </span>
      </div>

      <!-- Contender Tier -->
      <div
        class="flex flex-column sm:flex-row sm:justify-content-between sm:gap-3"
      >
        <div class="flex flex-row gap-2">
          <span class="material-symbols-outlined tier-icon-bg">star</span>
          <div
            class="flex flex-column sm:flex-row sm:align-items-center sm:gap-1"
          >
            <h3 class="body-4-bold" style="color: #344555">
              {{ $t("challenge.modal.contender") }}:
            </h3>
            <p class="body-4 text-gray-600">
              {{ $t("challenge.modal.contenderTier") }}
            </p>
          </div>
        </div>
        <span class="body-4-bold text-right ml-5 sm:ml-0 w-fit">
          {{ $t("challenge.modal.contenderGold") }}
        </span>
      </div>
    </section>
    <div class="flex flex-column gap-3 text-center">
      <p class="caption">{{ $t("challenge.modal.tiersDisclaimer") }}</p>
      <p class="caption">
        <a
          :href="TermsAndConditionsLink"
          target="_blank"
          class="caption link-5 underline"
          style="color: #004eeb"
         rel="noopener noreferrer">
          {{ $t("challenge.modal.term") }}
        </a>
        {{ $t("challenge.modal.apply") }}.
      </p>
    </div>
    <button
      class="primary-button-medium md:w-fit mx-auto w-full"
      @click="emit('close')"
    >
      {{ $t("forex-contract-specs.subtitle6") }}
    </button>
  </ModalCustom>
</template>

<script setup>
import ModalCustom from "~/components/utils/modal/ModalCustom.vue";

const TermsAndConditionsLink =
  "https://info.tvmarkets.com/gold-trade-challenge-terms-and-conditions?__hstc=45788219.218cc36be38c6ba2de24d047fe01a4c4.1749233751536.1749233751536.1749233751536.1&__hssc=45788219.1.1749233751536&__hsfp=1389937998";

const emit = defineEmits(["close"]);
const props = defineProps(["isVisible"]);
</script>
